var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("main-layout", { staticClass: "linksMainDiv" }, [
    _c("div", {
      directives: [
        {
          name: "show",
          rawName: "v-show",
          value: !_vm.loaded,
          expression: "!loaded"
        }
      ],
      staticClass: "top160",
      attrs: { id: "slinkHeader" }
    }),
    _vm._v(" "),
    _vm.loaded
      ? _c("div", { staticClass: "container has-text-white" }, [
          _c("img", {
            staticClass: "is-pulled-right top40 handCursor",
            attrs: { src: "/static/logQC.png", width: "150" },
            on: {
              click: function($event) {
                return _vm.navTo("", true)
              }
            }
          }),
          _vm._v(" "),
          _c("br"),
          _vm._v(" "),
          _c("div", { staticClass: "top40 is-size-1 top80 has-text-dark" }, [
            _c("img", {
              staticClass: "right5",
              attrs: { src: require("@/assets/img/chevronsY.png"), width: "30" }
            }),
            _c("span", { staticClass: "has-text-yell" }, [
              _c("b", [
                _vm._v(_vm._s(_vm.slink)),
                _c("span", { staticClass: "has-text-turk" }, [_vm._v(":links")])
              ])
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "is-size-5 top5 left30 has-text-light" }, [
              _vm._v("slink.com/" + _vm._s(_vm.slink) + ":links")
            ])
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "pageDescriptionContainer" }, [
            _c(
              "div",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.pageDescription,
                    expression: "pageDescription"
                  }
                ],
                staticClass: "pageDescription container"
              },
              [
                _vm._v(
                  "\n\t\t\t\t\t" + _vm._s(_vm.pageDescription) + "\n\t\t\t\t"
                )
              ]
            )
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "left20 top30 is-size-4" }, [
            !_vm.noShow
              ? _c(
                  "div",
                  {
                    staticClass: "top15 lpSub main",
                    on: {
                      click: function($event) {
                        return _vm.navTo(_vm.slink, true)
                      }
                    }
                  },
                  [
                    _c("div", { staticClass: "columns lpCols" }, [
                      _c(
                        "div",
                        { staticClass: "column lpTitle is-one-third" },
                        [
                          _c(
                            "div",
                            { staticClass: "top10 isPoppins is-size-2" },
                            [
                              _c("img", {
                                staticClass: "right3",
                                attrs: {
                                  src: require("@/assets/img/chevronsW.png"),
                                  width: "25"
                                }
                              }),
                              _c("b", [_vm._v(_vm._s(_vm.slink))])
                            ]
                          )
                        ]
                      ),
                      _vm._v(" "),
                      _c("div", { staticClass: "column is-size-5" }, [
                        _c("div", { staticClass: "lpDescHomeMain" }, [
                          _vm._v(_vm._s(_vm.description))
                        ])
                      ])
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "is-size-6 left15 top5" }, [
                      _vm._v("slink.com/"),
                      _c("b", [_vm._v(_vm._s(_vm.slink))])
                    ])
                  ]
                )
              : _vm._e(),
            _vm._v(" "),
            _c(
              "div",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.noShow,
                    expression: "noShow"
                  }
                ]
              },
              [
                _c("div", { staticClass: "left10 has-text-white" }, [
                  _vm._v(
                    "Sorry but there are no public subslinks being shared for this slink."
                  )
                ])
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: " top20" },
              _vm._l(_vm.links, function(item, i) {
                return _c(
                  "div",
                  {
                    key: i,
                    staticClass: "left20 top15 lpSub",
                    on: {
                      click: function($event) {
                        return _vm.navTo(item.url)
                      }
                    }
                  },
                  [
                    _c("div", { staticClass: "columns lpCols" }, [
                      _c(
                        "div",
                        {
                          staticClass:
                            "isPoppins lpTitle is-size-4 column is-one-third"
                        },
                        [_c("b", [_vm._v(":" + _vm._s(item.name))])]
                      ),
                      _vm._v(" "),
                      _c("div", { staticClass: "column is-size-5" }, [
                        _c("div", { staticClass: "lpDescHome" }, [
                          _vm._v(_vm._s(item.description))
                        ])
                      ])
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "is-size-6 left10" }, [
                      _vm._v("slink.com/" + _vm._s(_vm.slink)),
                      _c("b", [_vm._v(":" + _vm._s(item.name))])
                    ])
                  ]
                )
              }),
              0
            )
          ]),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass:
                "has-text-centered has-text-light alignBottom top80 bottom20"
            },
            [
              _c("div", { staticClass: "is-size-7" }, [
                _vm._v("Copyright ©2022 Slink, Inc.")
              ])
            ]
          )
        ])
      : _vm._e()
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-1c263345", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1c263345","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/Links.vue
// module id = null
// module chunks = 